import React, { memo, useContext } from 'react'
import { AppContext } from '../context'
import RouteList from './RouteList'
import { curateRoutes } from './AppRouter.hooks'
import { AppMenuProps } from './AppMenu.types'

function AppMenu({ routes }: AppMenuProps) {
    const context = useContext(AppContext)
    const curated = curateRoutes(context, routes)

    return <RouteList routes={curated} />
}

export default memo(AppMenu)
